<template>
  <v-dialog
    v-model="dialogOpen"
    v-if="dialogOpen"
    content-class="my-custom-dialog"
    transition="dialog-top-transition"
    persistent
    max-width="630"
    @keydown.esc="close"
  >
    <v-card class="glass-card">
      <v-form ref="addTable" @submit.prevent="addTable">
        <v-card-title class="glass-header">
          <h2 class="gradient-text">Dodaj stol</h2>
          <v-spacer></v-spacer>
          <v-icon large color="white" @click="close">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="glass-body">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newTable.name"
                  label="Naziv"
                  placeholder="Unesite naziv stola"
                  dense
                  outlined
                  hide-details="auto"
                  class="filter-select"
                  :rules="[rules.req, rules.nameValid]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mt-3">
              <v-col cols="12">
                <v-checkbox
                  v-model="persist"
                  label="Zadrži stol nakon izdavanja računa"
                  color="#3989C9"
                  hide-details
                  class="custom-checkbox"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="glass-actions">
          <v-spacer></v-spacer>
          <v-btn class="soft-button" type="submit">
            <v-icon small class="mr-2">mdi-plus</v-icon>
            Dodaj stol
          </v-btn>
          <v-btn class="cancel-button" @click="close">
            <v-icon small class="mr-2">mdi-close</v-icon>
            Odustani
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '@/plugins/rules'
export default {
  inject: ['showMsgBox'],
  data () {
    return {
      dialogOpen: true,
      name: '',
      persist: true,
      newTable: {},
      rules: {
        req: rules.req(),
        nameValid: rules.nameValid()
      }
    }
  },
  props: {
    table: {
      type: Object,
      default: () => {}
    },
    tables: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    close () {
      this.$emit('closeAddTableDialog')
    },
    addTable () {
      if (!this.$refs.addTable.validate()) return
      if (this.isUnique()) {
        this.$emit('addTable', this.newTable, this.persist)
      } else {
        this.showMsgBox({ text: `Već postoji stol s imenom ${this.newTable.name}. Odaberi jedinstveno ime.`, actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
      }
    },
    isUnique () {
      return !this.tables.some(t => t.name === this.newTable.name)
    }
  },

  created () {
    this.newTable = { ...this.table }
  }
}
</script>

<style scoped>
.v-dialog__content >>> .my-custom-dialog {
  border-radius: 16px;
}

/* Glass Card Style */
.glass-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.1) !important;
  overflow: hidden;
}

/* Glass Header with Gradient */
.glass-header {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px 16px !important;
  position: relative;
}

/* Gradient Text for Title */
.gradient-text {
  font-size: 24px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.95) 50%,
    rgba(255, 255, 255, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
}

/* Glass Body */
.glass-body {
  background: transparent !important;
  padding: 24px 16px !important;
}

/* Glass Actions */
.glass-actions {
  background: transparent !important;
  padding: 16px 24px 24px !important;
}

/* Filter Select Input */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 40px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-text-field__slot input {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

/* Custom Checkbox */
.custom-checkbox >>> .v-label {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
  letter-spacing: 0.3px !important;
}

.custom-checkbox >>> .v-icon {
  color: #3989C9 !important;
}

/* Soft Button Style (Primary) */
.soft-button {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #3989C9 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(57, 137, 201, 0.15) !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin-left: 8px !important;
}

.soft-button:hover {
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  border-color: rgba(57, 137, 201, 0.3) !important;
  transform: translateY(-1px);
}

.soft-button .v-icon {
  font-size: 18px !important;
  color: #3989C9 !important;
}

/* Cancel Button Style */
.cancel-button {
  background: rgba(245, 245, 245, 0.8) !important;
  color: rgba(70, 70, 80, 0.9) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(120, 120, 130, 0.15) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  margin-left: 8px !important;
}

.cancel-button:hover {
  background: rgba(230, 230, 230, 0.9) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
  border-color: rgba(120, 120, 130, 0.25) !important;
  transform: translateY(-1px);
}

.cancel-button .v-icon {
  font-size: 18px !important;
  color: rgba(70, 70, 80, 0.9) !important;
}
</style>
